import { render, staticRenderFns } from "./electrical_table.vue?vue&type=template&id=1d4ed64d&"
import script from "./electrical_table.vue?vue&type=script&lang=js&"
export * from "./electrical_table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports